<template>
  <div>
    <app-cells class="cells--end-vertical">
      <app-button @click.native="showBuilderModal">Chart constructor</app-button>
      <app-form-group class="form-group--no-indent" label="Date range">
        <div class="date-picker-wrapper">
          <VueCtkDateTimePicker
            id="date_picker_balance"
            v-model="filter_dates"
            :custom-shortcuts="custom_shortcuts"
            button-color="#77b017"
            class="custom-date-time-picker custom-date-time-picker--range"
            color="#77b017"
            format="YYYY-MM-DD"
            formatted="ll"
            label="Select dates"
            locale="en"
            no-header
            no-label
            noClearButton
            overlay
            range
            shortcut="last180Days"
            @is-hidden="onIsHiddenPicker"
          />
          <div v-if="date_picker_error" class="date-picker-wrapper__error">Choose an end date</div>
        </div>
      </app-form-group>
      <app-form-group label="Cohort period" class="form-group--no-indent" style="min-width: 220px">
        <template #additional>
          <button @click="onChangeCalendarType('calendarType', 'filter_cohort_period')" style="line-height: 0">
            <img src="@/assets/img/calendar-rotate.svg" alt="Change type">
          </button>
        </template>
        <app-date-picker
          @input="loadCharts"
          v-model="filter_cohort_period"
          :format="calendarType === 'month' ? 'MMM YYYY' : 'DD MMM YYYY'"
          :type="calendarType"
          placeholder="Cohort period"
          range
        />
      </app-form-group>
      <app-form-group label="Customer period" class="form-group--no-indent" style="min-width: 220px">
        <template #additional>
          <button @click="onChangeCalendarType('calendarTypeCustomer', 'filter_customer_period')" style="line-height: 0">
            <img src="@/assets/img/calendar-rotate.svg" alt="Change type">
          </button>
        </template>
        <app-date-picker
          @input="loadCharts"
          v-model="filter_customer_period"
          :format="calendarTypeCustomer === 'month' ? 'MMM YYYY' : 'DD MMM YYYY'"
          :type="calendarTypeCustomer"
          placeholder="Customer period"
          range
        />
      </app-form-group>
      <app-form-group label="Actual period" class="form-group--no-indent" style="min-width: 220px">
        <template #additional>
          <button @click="onChangeCalendarType('calendarTypeActual', 'filter_actual_period')" style="line-height: 0">
            <img src="@/assets/img/calendar-rotate.svg" alt="Change type">
          </button>
        </template>
        <app-date-picker
          @input="loadCharts"
          v-model="filter_actual_period"
          :format="calendarTypeActual === 'month' ? 'MMM YYYY' : 'DD MMM YYYY'"
          :type="calendarTypeActual"
          placeholder="Actual period"
          range
        />
      </app-form-group>
    </app-cells>
    <app-cells>
      <app-form-group class="form-group--no-indent" label="Mode">
        <app-filters
          v-model="mode_filter"
          :filters="mode_filters"
          name="filterMode"
          @change="loadCharts"
        />
      </app-form-group>
      <app-form-group class="form-group--no-indent" label="Granularity">
        <app-filters
          v-model="granularity_filter"
          :filters="granularity_filters"
          name="filterGranularity"
          @change="loadCharts"
        />
      </app-form-group>
      <app-form-group class="form-group--no-indent" label="Quick payment">
        <app-filters
          v-model="payment_filter"
          :filters="payment_filters"
          name="filterPayment"
          @change="loadCharts"
        />
      </app-form-group>
    </app-cells>
    <app-flex-grid :rows="[[1, 1, 1, 1, 1, 1]]" alignItems="start">
      <template #col-1-1>
        <app-form-group class="form-group--no-indent" label="Country">
          <app-select
            v-model="country_ids"
            :closeOnSelect="false"
            :options="country_options"
            :reduce="item => item.code"
            multiple
            placeholder="Country"
            @input="loadCharts"
          />
        </app-form-group>
      </template>
      <template #col-1-2>
        <app-form-group class="form-group--no-indent" label="Country groups">
          <app-select
            v-model="country_group_codes"
            :closeOnSelect="false"
            :options="country_group_codes_options"
            :reduce="item => item.code"
            multiple
            placeholder="Country groups"
            @input="loadCharts"
          />
        </app-form-group>
      </template>
      <template #col-1-3>
        <app-form-group class="form-group--no-indent" label="Product">
          <app-select
            v-model="product_codes"
            :closeOnSelect="false"
            :options="product_codes_options"
            :reduce="item => item.code"
            multiple
            placeholder="Product"
            @input="loadCharts"
          />
        </app-form-group>
      </template>
      <template #col-1-4>
        <app-form-group class="form-group--no-indent" label="Manager">
          <app-select
            v-model="manager_ids"
            :closeOnSelect="false"
            :options="managers_options"
            :reduce="item => item.id"
            label="full_name"
            multiple
            placeholder="Manager"
            @input="loadCharts"
          />
        </app-form-group>
      </template>
      <template #col-1-5>
        <app-form-group class="form-group--no-indent" label="Ad platform">
          <app-select
            v-model="ad_platform_codes"
            :closeOnSelect="false"
            :options="ad_platform_codes_options"
            :reduce="item => item.code"
            multiple
            placeholder="Ad platform"
            @input="loadCharts"
          />
        </app-form-group>
      </template>
      <template #col-1-6>
        <app-form-group class="form-group--no-indent" label="Traffic type">
          <app-select
            v-model="traffic_types"
            :closeOnSelect="false"
            :options="traffic_types_options"
            :reduce="item => item.code"
            multiple
            placeholder="Traffic type"
            @input="loadCharts"
          />
        </app-form-group>
      </template>
    </app-flex-grid>
    <app-flex-grid :rows="[[1, 1, 1, 1, 1, 1]]" alignItems="start">
      <template #col-1-1>
        <app-form-group class="form-group--no-indent" label="Advertising source">
          <app-select
            v-model="adv_source_ids"
            :closeOnSelect="false"
            :options="adv_source_options"
            :reduce="item => item.code"
            multiple
            placeholder="Advertising source"
            @input="loadCharts"
          />
        </app-form-group>
      </template>
      <template #col-1-2>
        <app-form-group class="form-group--no-indent" label="Status group">
          <app-select
            v-model="status_groups"
            :closeOnSelect="false"
            :options="status_groups_options"
            :reduce="item => item.code"
            multiple
            placeholder="Status group"
            @input="loadCharts"
          />
        </app-form-group>
      </template>
      <template #col-1-3>
        <app-form-group class="form-group--no-indent" label="Status">
          <app-select
            v-model="status_codes"
            :closeOnSelect="false"
            :options="status_options"
            :reduce="item => item.code"
            multiple
            placeholder="Status"
            @input="loadCharts"
          />
        </app-form-group>
      </template>
      <template #col-1-4>
        <app-form-group class="form-group--no-indent" label="Exclude statuses">
          <app-select
            v-model="exclude_statuses"
            :closeOnSelect="false"
            :options="status_options"
            :reduce="item => item.code"
            multiple
            placeholder="Exclude statuses"
            @input="loadCharts"
          />
        </app-form-group>
      </template>
      <template #col-1-5>
        <app-form-group class="form-group--no-indent" label="Route">
          <app-select
            v-model="route_ids"
            :closeOnSelect="false"
            :display-field="option => `${option.name} ${option.duration}`"
            :options="route_options"
            :reduce="item => item.id"
            multiple
            placeholder="Route"
            @input="loadCharts"
          />
        </app-form-group>
      </template>
      <template #col-1-6>
        <app-form-group class="form-group--no-indent" label="Safari park">
          <app-select
            v-model="safari_park_ids"
            :closeOnSelect="false"
            :options="safari_park_options"
            :reduce="item => item.code"
            multiple
            placeholder="Safari park"
            @input="loadCharts"
          />
        </app-form-group>
      </template>
    </app-flex-grid>
    <app-flex-grid :rows="[[1, 1, 1, 1, 1, 1]]" alignItems="start">
      <template #col-1-1>
        <app-form-group class="form-group--no-indent" label="Join / private">
          <app-select
            v-model="join_private_codes"
            :closeOnSelect="false"
            :options="join_private_codes_options"
            :reduce="item => item.code"
            multiple
            placeholder="Join / private"
            @input="loadCharts"
          />
        </app-form-group>
      </template>
      <template #col-1-2>
        <app-form-group class="form-group--no-indent" label="Climbing tour length">
          <app-select
            v-model="climbing_tour_length_buckets"
            :closeOnSelect="false"
            :options="climbing_tour_length_buckets_options"
            :reduce="item => item.code"
            multiple
            placeholder="Climbing tour length"
            @input="loadCharts"
          />
        </app-form-group>
      </template>
      <template #col-1-3>
        <app-form-group class="form-group--no-indent" label="Safari tour length">
          <app-select
            v-model="safari_tour_length_buckets"
            :closeOnSelect="false"
            :options="safari_tour_length_buckets_options"
            :reduce="item => item.code"
            multiple
            placeholder="Safari tour length"
            @input="loadCharts"
          />
        </app-form-group>
      </template>
      <template #col-1-4>
        <app-form-group class="form-group--no-indent" label="Domain">
          <app-select
            v-model="domain_ids"
            :closeOnSelect="false"
            :options="domain_options"
            :reduce="item => item.id"
            label="domain_name"
            multiple
            placeholder="Domain"
            @input="loadCharts"
          />
        </app-form-group>
      </template>
    </app-flex-grid>
    <marketing-dashboard-charts
      :charts="charts"
      :dashboard-info="dashboard_info"
      :is-loaded="is_loaded"
    />
    <modal
      :adaptive="true"
      :height="'auto'"
      :scrollable="true"
      :width="720"
      class="modal-not-overflow"
      name="dashboard-builder-modal"
    >
      <div class="popup">
        <button class="popup__close" type="button" @click="closeBuilderModal"></button>
        <div class="popup__title">Chart constructor</div>
        <div class="popup__body">
          <app-form-group label="Segment">
            <app-select
              v-model="builder_segment"
              :options="segment_options"
              :reduce="item => item.code"
              placeholder="Segment"
            />
          </app-form-group>
          <div class="dashboard-builder-grid">
            <div v-for="option in sections_options" :key="option.code" class="dashboard-builder-grid__item">
              <div class="dashboard-builder-grid__title">{{ option.name }}</div>
              <label class="checkbox" v-for="metric in option.metrics" :key="metric.code">
                <span class="checkbox__text">{{ metric.name }}</span>
                <input
                  v-model="builder_metrics"
                  :value="metric.code"
                  type="checkbox"
                />
                <span class="checkbox__checkmark"></span>
              </label>
            </div>
          </div>
          <app-cells :indent="false" position="center">
            <app-button @click.native="onSubmitConstructor">Apply</app-button>
          </app-cells>
        </div>
      </div>
    </modal>
  </div>
</template>

<script>
import {
  getClimbingRoutes,
  getCountries,
  getLeadsAdvSources,
  getLeadsStatuses,
  getSafariNationalPark,
  getUsers,
  getLeadsAnalyticsDashboardBuilderOptions,
  postLeadsAnalyticsDashboardBuilder
} from '@/http'
import VueCtkDateTimePicker from 'vue-ctk-date-time-picker'
import 'vue-ctk-date-time-picker/dist/vue-ctk-date-time-picker.css'
import MarketingDashboardCharts from './components/MarketingDashboardCharts'

export default {
  name: 'CRMAnalyticsDashboardBuilder',
  components: {VueCtkDateTimePicker, MarketingDashboardCharts},
  data() {
    return {
      is_loaded: false,
      filter_dates: null,
      date_picker_error: false,
      custom_shortcuts: [
        {key: 'last7Days', label: 'Last 7 days', value: 7},
        {key: 'last30Days', label: 'Last 30 days', value: 30},
        {key: 'last60Days', label: 'Last 60 days', value: 60},
        {key: 'last90Days', label: 'Last 90 days', value: 90},
        {key: 'last180Days', label: 'Last 180 days', value: 180},
        {key: 'thisYear', label: 'This year', value: 'year'},
        {key: 'lastYear', label: 'Last year', value: '-year'},
      ],
      date_picker_dates_error: false,
      mode_filter: 'cohort',
      filter_cohort_period: [],
      filter_customer_period: [],
      filter_actual_period: [],
      mode_filters: [
        {value: 'cohort', label: 'Cohort'},
        {value: 'customer', label: 'Customer'},
        {value: 'actual', label: 'Actual'},
      ],
      granularity_filter: 'month',
      granularity_filters: [
        {value: 'day', label: 'Day'},
        {value: 'week', label: 'Week'},
        {value: 'month', label: 'Month'},
        {value: 'quarter', label: 'Quarter'},
      ],
      payment_filter: 'include',
      payment_filters: [
        {value: 'include', label: 'Include'},
        {value: 'exclude', label: 'Exclude'},
        {value: 'include_only', label: 'Include only'},
      ],
      country_options: [],
      country_ids: null,
      country_group_codes_options: [
        {code: 'tier_1', name: 'Main countries'},
        {code: 'tier_2', name: 'Secondary countries'},
        {code: 'other', name: 'Other'},
        {code: 'unknown', name: 'Unknown'},
      ],
      country_group_codes: null,
      product_codes_options: [
        {code: 'climb', name: 'Climb'},
        {code: 'safari', name: 'Safari'},
        {code: 'safari_climb', name: 'Safari + Climb'},
        {code: 'other', name: 'Other'},
      ],
      product_codes: null,
      ad_platform_codes_options: [
        {code: 'google', name: 'Google Ads'},
        {code: 'bing', name: 'Bing Ads'},
        {code: 'yandex', name: 'Yandex Direct'},
        {code: 'meta', name: 'Meta Ads'},
        {code: 'manual', name: 'Manual'},
        {code: 'other', name: 'Other'},
        {code: 'unknown', name: 'Unknown'},
      ],
      ad_platform_codes: null,
      traffic_types_options: [
        {code: 'paid_ads', name: 'Paid ads'},
        {code: 'organic', name: 'Organic'},
        {code: 'referral', name: 'Referral'},
        {code: 'direct', name: 'Direct'},
        {code: 'unknown', name: 'Unknown'},
      ],
      traffic_types: null,
      adv_source_options: [],
      adv_source_ids: null,
      status_options: [
        {code: 'double_request', name: 'Double request'},
        {code: 'lead_magnet', name: 'Lead Magnet'},
      ],
      status_codes: null,
      exclude_statuses: ['double_request', 'lead_magnet'],
      status_groups_options: [
        {code: 'other', name: 'Other'},
        {code: 'negotiation', name: 'Negotiation'},
        {code: 'customer', name: 'Customers'},
        {code: 'lost', name: 'Lost'},
        {code: 'potential_lost', name: 'Potential lost'},
        {code: 'spam', name: 'Spam'},
      ],
      status_groups: null,
      managers_options: [],
      manager_ids: null,
      domain_options: [],
      domain_ids: null,
      route_options: [],
      route_ids: null,
      safari_park_options: [],
      safari_park_ids: null,
      join_private_codes_options: [
        {code: 'private', name: 'Private'},
        {code: 'join', name: 'Join'},
      ],
      join_private_codes: null,
      climbing_tour_length_buckets_options: [
        {code: '1-5', name: '1-5 days'},
        {code: '6-8', name: '6-8 days'},
        {code: '9+', name: '9+ days'},
      ],
      climbing_tour_length_buckets: null,
      safari_tour_length_buckets_options: [
        {code: '1-6', name: '1-6 days'},
        {code: '7-9', name: '7-9 days'},
        {code: '10+', name: '10+ days'},
      ],
      safari_tour_length_buckets: null,
      charts: [],
      dashboard_info: {},
      segment_options: [],
      sections_options: [],
      builder_metrics: [],
      builder_segment: null,
      calendarType: 'month',
      calendarTypeCustomer: 'month',
      calendarTypeActual: 'month',
    }
  },
  created() {
    getCountries().then(response => {
      this.country_options = response.data
    })
    getLeadsStatuses().then(response => {
      this.status_options = response.data
    })
    getLeadsAdvSources().then(response => {
      this.adv_source_options = response.data
    })
    getClimbingRoutes().then(response => {
      this.route_options = response.data
    })
    getSafariNationalPark().then(response => {
      this.safari_park_options = response.data
    })
    getUsers({group: 'sales_manager', is_active: true}).then(response => {
      this.managers_options = response.data
    })
    getLeadsAnalyticsDashboardBuilderOptions().then(response => {
      this.segment_options = response.data.segments
      this.sections_options = response.data.sections
      this.domain_options = response.data.domains || []
    })
    setTimeout(() => {
      this.$nextTick(() => {
        this.loadCharts()
      })
    }, 0)
  },
  methods: {
    onSubmitConstructor() {
      this.loadCharts()
      this.closeBuilderModal()
    },
    onChangeCalendarType(type, period) {
      this[type] = this[type] === 'month' ? 'week' : 'month'
      this[period] = []
      this.loadCharts()
    },
    loadCharts() {
      this.is_loaded = false
      postLeadsAnalyticsDashboardBuilder(this.removeNullFields({
        filters: {
          date_from: this.filter_dates.start,
          date_to: this.filter_dates.end,
          mode: this.mode_filter,
          granularity: this.granularity_filter,
          country_ids: this.country_ids,
          country_group_codes: this.country_group_codes,
          product_codes: this.product_codes,
          manager_ids: this.manager_ids,
          domain_ids: this.domain_ids,
          ad_platform_codes: this.ad_platform_codes,
          traffic_types: this.traffic_types,
          adv_source_ids: this.adv_source_ids,
          status_codes: this.status_codes,
          status_groups: this.status_groups,
          exclude_statuses: this.exclude_statuses,
          route_ids: this.route_ids,
          safari_park_ids: this.safari_park_ids,
          join_private_codes: this.join_private_codes,
          climbing_tour_length_buckets: this.climbing_tour_length_buckets,
          safari_tour_length_buckets: this.safari_tour_length_buckets,
          quick_payment: this.payment_filter,
          cohort_date_from: this.filter_cohort_period[0],
          cohort_date_to: this.filter_cohort_period[1],
          customer_date_from: this.filter_customer_period[0],
          customer_date_to: this.filter_customer_period[1],
          actual_date_from: this.filter_actual_period[0],
          actual_date_to: this.filter_actual_period[1],
        },
        gridlines: {
          segment_by: this.builder_segment,
          metrics: this.builder_metrics,
        }
      }))
        .then((response) => {
          this.dashboard_info = response.data.info || {}
          this.charts = response.data.charts || []
          this.is_loaded = true
        })
    },
    removeNullFields(data) {
      return Object.entries(data).reduce((result, [key, value]) => {
        if (value === null) return result

        if (value && typeof value === 'object' && !Array.isArray(value)) {
          result[key] = this.removeNullFields(value)
        } else {
          result[key] = value
        }

        return result
      }, {})
    },
    showBuilderModal() {
      this.$modal.show('dashboard-builder-modal')
    },
    closeBuilderModal() {
      this.$modal.hide('dashboard-builder-modal')
    },
    onIsHiddenPicker() {
      if (this.filter_dates?.start && this.filter_dates?.end) {
        this.date_picker_error = false
        this.loadCharts()
      } else this.date_picker_error = true
    },
  }

}
</script>

<style lang="sass" scoped>
.date-picker-wrapper
  position: relative

.date-picker-wrapper__error
  position: absolute
  bottom: -18px
  color: $color-error
  font-size: 12px

.dashboard-builder-grid
  display: grid
  grid-template-columns: repeat(4, 1fr)
  gap: 10px
  margin-bottom: 30px

.dashboard-builder-grid__title
  font-weight: 600

.dashboard-builder-grid__item
  display: flex
  flex-direction: column
  gap: 5px
</style>
